import React from "react";
import Edit from "../../../../assets/icons/edit.svg";
import View from "../../../../assets/icons/view.svg";
const EditViewSwitch = (props) => {
  return (
    <div
      className="btn-group btn-group-toggle ml-auto align-item-center"
      data-toggle="buttons"
    >
      <label
        className={[
          "btn btn-secondary-toggle has-icon",
          props.editView ? "active" : "",
        ].join(" ")}
        onClick={props.toggleEditHandler}
      >
        <input type="radio" name="week" readOnly />
        <img src={Edit} alt="Edit" />
      </label>
      <label
        className={[
          "btn btn-secondary-toggle has-icon",
          props.editView ? "" : "active",
        ].join(" ")}
        onClick={props.toggleViewHandler}
      >
        <input
          type="radio"
          name="month"
          readOnly
          disabled={!props.hasValidValue}
        />
        <img src={View} alt="View" />
      </label>
    </div>
  );
};

export default EditViewSwitch;
